import React, { useContext } from "react";
import { Tab } from "semantic-ui-react";
import { AppContext } from "app-provider";
import { ImporterForm, ResupplyImporterForm } from "components/importers";
import StartImportForm from "./start-import-form";
import api from "api";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Modal } from "components/ui";
import AddCompanyImporter from "./add-company-importer";
import CompanyImportHistory from "./company-import-history";

export const CompanyProfileContext = React.createContext();

const CompanyProfile = () => {
  const { companies } = useContext(AppContext);

  const { companyId } = useParams();

  const companyName = companies.find((x) => x.value == companyId)?.text;

  const companyFormOptions = useQuery({
    queryKey: [`form-options`, companyId],
    queryFn: async () => {
      const response = await api.get(`/api/form-options/${companyId}`);
      return response.data;
    },
  });

  const modalRef = React.useRef();

  return (
    <CompanyProfileContext.Provider
      value={{
        ...(companyFormOptions?.data ?? {}),
      }}
    >
      <div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr auto" }}>
          <h1>{companyName}</h1>
          <button onClick={() => modalRef.current.open()}>Add Importer</button>
        </div>
        <Tab
          panes={[
            {
              menuItem: "Importer",
              render: () => (
                <StartImportForm
                  companyId={companyId}
                  companyName={companyName}
                />
              ),
            },
            {
              menuItem: "History",
              render: () => (
                <CompanyImportHistory
                  companyId={companyId}
                  companyName={companyName}
                />
              ),
            },
            companyFormOptions.data?.import_types.includes("Compliance") && {
              menuItem: "Compliance",
              render: () => <ImporterForm importType="Compliance" />,
            },
            companyFormOptions.data?.import_types.includes("Resupply") && {
              menuItem: "Resupply",
              render: () => <ResupplyImporterForm />,
            },
            companyFormOptions.data?.import_types.includes("Snap") && {
              menuItem: "Snap",
              render: () => <ImporterForm importType="Snap" />,
            },
            companyFormOptions.data?.import_types.includes("Demographics") && {
              menuItem: "Demographics",
              render: () => <ImporterForm importType="Demographics" />,
            },
            companyFormOptions.data?.import_types.includes("Insurance") && {
              menuItem: "Insurance",
              render: () => <ImporterForm importType="Insurance" />,
            },
            companyFormOptions.data?.import_types.includes("Therapy Data") && {
              menuItem: "Therapy Data",
              render: () => <ImporterForm importType="Therapy Data" />,
            },
            companyFormOptions.data?.import_types.includes("Tracking") && {
              menuItem: "Tracking",
              render: () => <ImporterForm importType="Tracking" />,
            },
            // Per-vendor tracking importers ("Tracking-<Vendor>") live under the internal company.
            // Render an editable tab for each so admins can manage vendor rules (S3DEV2-7448).
            ...(companyFormOptions.data?.import_types ?? [])
              .filter((t) => t.startsWith("Tracking-"))
              .map((t) => ({
                menuItem: t.replace("Tracking-", "") + " Tracking",
                render: () => <ImporterForm importType={t} />,
              })),
          ].filter(Boolean)}
          renderActiveOnly={true}
        />
        <Modal ref={modalRef} fade>
          <AddCompanyImporter
            closeModal={() => modalRef.current.close()}
            companyName={companyName}
            companyId={companyId}
            companyImportTypes={companyFormOptions.data?.import_types}
          />
        </Modal>
      </div>
    </CompanyProfileContext.Provider>
  );
};

export default CompanyProfile;
